import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class StockTransferAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            warehouses: [],
            stockItems: [],
            items: [{ stock_item_id: '', quantity: '' }],
            formData : {
                from_warehouse_id:'',
                to_warehouse_id:'',
                transfer_date: new Date().toISOString().split('T')[0],
                notes:''
            }
        }
    }

    componentDidMount() {
        this.fetchWarehouses();
        this.fetchStockItems();
    }

    fetchWarehouses = async () => {
        try {
            const response = await apiCall('business/stock/warehouse/select-list','get');
            this.setState({warehouses: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    fetchStockItems = async () => {
        try {
            const response = await apiCall('business/stock/item/select-list','get');
            this.setState({stockItems: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (e) => {
        const {id,value} = e.target;
        this.setState(prevState => ({
            formData : {
                ...prevState.formData,
                [id] : value
            }
        }))
    }

    handleItemChange = (index, field, value) => {
        const newItems = [...this.state.items];
        newItems[index][field] = value;
        this.setState({ items: newItems });
    }

    addItem = () => {
        this.setState(prevState => ({
            items: [...prevState.items, { stock_item_id: '', quantity: '' }]
        }));
    }

    removeItem = (index) => {
        const newItems = this.state.items.filter((_, i) => i !== index);
        this.setState({ items: newItems });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        // Validasyon
        if(this.state.formData.from_warehouse_id === this.state.formData.to_warehouse_id) {
            mainHelper.toastMessage('error', 'Kaynak ve hedef depo aynı olamaz!');
            return;
        }

        if(this.state.items.length === 0 || !this.state.items[0].stock_item_id) {
            mainHelper.toastMessage('error', 'En az bir stok kalemi eklemelisiniz!');
            return;
        }

        this.setState({loading:true});
        const {formData, items} = this.state;

        const transferData = {
            ...formData,
            items: items.filter(item => item.stock_item_id && item.quantity)
        };

        try {
            const response = await apiCall('business/stock/transfer/add','post', JSON.stringify(transferData), {
                form: e.target
            });
            this.setState({loading:false});
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.props.history.push('/stock/transfers');
            }
        }catch (e) {
            this.setState({loading:false});
        }
    }

    render() {
        const {loading, warehouses, stockItems, formData, items} = this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Transfer Oluştur"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Transferler", navigate: "stock/transfers" },
                                { name: "Yeni Transfer", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Kaynak Depo *</label>
                                                    <select
                                                        id="from_warehouse_id"
                                                        className="form-control"
                                                        value={formData.from_warehouse_id}
                                                        onChange={this.handleChange}
                                                        required
                                                    >
                                                        <option value="">Kaynak Depo Seçiniz</option>
                                                        {warehouses.map(warehouse => (
                                                            <option key={warehouse.id} value={warehouse.id}>
                                                                {warehouse.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Hedef Depo *</label>
                                                    <select
                                                        id="to_warehouse_id"
                                                        className="form-control"
                                                        value={formData.to_warehouse_id}
                                                        onChange={this.handleChange}
                                                        required
                                                    >
                                                        <option value="">Hedef Depo Seçiniz</option>
                                                        {warehouses.map(warehouse => (
                                                            <option key={warehouse.id} value={warehouse.id}>
                                                                {warehouse.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row clearfix">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Transfer Tarihi *</label>
                                                    <input
                                                        id="transfer_date"
                                                        className="form-control"
                                                        type="date"
                                                        value={formData.transfer_date}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <hr />
                                        <h5>Transfer Kalemleri</h5>
                                        {items.map((item, index) => (
                                            <div className="row clearfix align-items-end" key={index}>
                                                <div className="col-lg-6 col-md-5">
                                                    <div className="form-group">
                                                        <label>Stok Kalemi *</label>
                                                        <select
                                                            data-validation-field={`items.${index}.stock_item_id`}
                                                            className="form-control"
                                                            value={item.stock_item_id}
                                                            onChange={(e) => this.handleItemChange(index, 'stock_item_id', e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Stok Kalemi Seçiniz</option>
                                                            {stockItems.map(stockItem => (
                                                                <option key={stockItem.id} value={stockItem.id}>
                                                                    {stockItem.name} {stockItem.sku ? `(${stockItem.sku})` : ''}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-5">
                                                    <div className="form-group">
                                                        <label>Miktar *</label>
                                                        <input
                                                            data-validation-field={`items.${index}.quantity`}
                                                            className="form-control"
                                                            placeholder="Miktar"
                                                            type="number"
                                                            step="0.01"
                                                            value={item.quantity}
                                                            onChange={(e) => this.handleItemChange(index, 'quantity', e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-2">
                                                    <div className="form-group">
                                                        {items.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-block"
                                                                onClick={() => this.removeItem(index)}
                                                            >
                                                                <i className="icon-trash"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="row clearfix">
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-success"
                                                    onClick={this.addItem}
                                                >
                                                    <i className="icon-plus"></i> Kalem Ekle
                                                </button>
                                            </div>
                                        </div>

                                        <hr />
                                        <div className="row clearfix">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label>Notlar</label>
                                                    <textarea
                                                        id="notes"
                                                        className="form-control"
                                                        placeholder="Notlar"
                                                        rows="3"
                                                        value={formData.notes}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block" disabled={true} style={{textAlign: "-webkit-center"}}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                <button className="btn btn-outline-primary btn-block" type="submit">
                                                    Transfer Oluştur
                                                </button>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(StockTransferAdd));




